import React from 'react';

export function Goal(props) {
    return (
        <svg
            x="0px"
            y="0px"
            width="200px"
            height="200px"
            viewBox="0 0 200 200"
            enableBackground="new 0 0 200 200"
            {...props}
        >
            <g id="Goal">
                <path
                    d="M100.7,8.5C50.8,8.5,10,49.3,10,99.2c0,49.899,40.8,90.7,90.7,90.7s90.7-40.801,90.7-90.7C191.4,49.3,150.6,8.5,100.7,8.5
            		 M162,147.1l-1.6-10.898l-28,6l-15.102,25L127.6,172.1c-8.4,3.102-17.4,4.9-26.9,4.9s-18.5-1.8-26.9-4.9L84.1,167.2L69,142.2l-28-6
            		L39.4,147.1C29.1,133.9,22.9,117.3,22.9,99.2c0-0.8,0.1-1.7,0.1-2.5l7.4,7.8l19.7-21.9l-3-28.7L36,55.9
            		C46.2,40.7,61.6,29.4,79.6,24.3L74.3,34.2l26.4,11.3l26.4-11.3l-5.302-9.9c18.102,5.1,33.5,16.4,43.602,31.6L154.3,53.8l-3,28.7
            		l19.602,21.9l7.398-7.8c0,0.8,0.102,1.7,0.102,2.5C178.6,117.3,172.3,133.9,162,147.1 M100.7,69l31.7,23.4L120.3,129.5H81.1
            		L68.9,92.4L100.7,69z"
                />
            </g>
        </svg>
    );
}

export function Card(props) {
    return (
        <svg
            version="1.1"
            x="0px"
            y="0px"
            width="200px"
            height="200px"
            viewBox="0 0 200 200"
            enableBackground="new 0 0 200 200"
            {...props}
        >
            <path
                fill={props.color}
                d="M159,171.992c0,9.394-7.615,17.008-17.008,17.008H56.008C46.615,189,39,181.386,39,171.992V30.008
            	C39,20.615,46.615,13,56.008,13h85.984C151.385,13,159,20.615,159,30.008V171.992z"
            />
        </svg>
    );
}

export function Cards(props) {
    return (
        <svg
            x="0px"
            y="0px"
            width="200px"
            height="200px"
            viewBox="0 0 200 200"
            enableBackground="new 0 0 200 200"
            {...props}
        >
            <path
                fill="yellow"
                d="M125.747,148.817c1.343,7.594-3.726,14.838-11.319,16.18l-69.51,12.287c-7.593,1.342-14.837-3.726-16.179-11.319
        	L8.449,51.184c-1.342-7.594,3.726-14.838,11.319-16.18l69.511-12.287c7.593-1.342,14.837,3.726,16.179,11.319L125.747,148.817z"
            />
            <path
                fill="red"
                d="M177.359,163.628c-0.899,7.657-7.837,13.138-15.495,12.238l-70.107-8.233c-7.658-0.899-13.137-7.836-12.238-15.495
                L93.112,36.373c0.899-7.658,7.838-13.138,15.495-12.239l70.107,8.232c7.658,0.9,13.138,7.837,12.238,15.496L177.359,163.628z"
            />
        </svg>
    );
}

export function SimpleCard(props) {
    let { width = 115, height = 140, color = 'black', radius = 0 } = props;
    return (
        <svg className="sm-card" width={width} height={height}>
            <rect rx={radius} ry={radius} width={width} height={height} fill={color} />
        </svg>
    );
}

export function SubOut(props) {
    return (
        <svg
            x="0px"
            y="0px"
            width="200px"
            height="200px"
            viewBox="0 0 200 200"
            enableBackground="new 0 0 200 200"
            {...props}
        >
            <polygon points="4.834,98.708 94.429,160.551 94.429,120.526 191,120.526 191,76.891 94.429,76.891 94.429,36.866 " />
        </svg>
    );
}

export function Injury({ width = 20, height = 20, colorCircle = '#cc0000', colorPlus = 'white', ...otherProps }) {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" {...otherProps}>
            <circle r="10" cx="10" cy="10" fill={colorCircle} />
            <rect x="7.7" y="2.8" width="4.5" height="14" fill={colorPlus} />
            <rect x="3" y="7.5" width="14" height="4.5" fill={colorPlus} />
        </svg>
    );
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/SportIcons.js
 **/